module.exports = __webpack_public_path__ + "static/wizard-right-8cbc1eeebd9c96bd7836712dd73896b5.png";